import { Subject } from 'rxjs';

import { ComponentRef } from '@angular/core';
import { GlobalPositionStrategy } from '@angular/cdk/overlay';
import { DialogRef, DialogConfig } from '@angular/cdk/dialog';

import { DialogPositionInterface } from '@/app/shared/components/ui/dialog/interfaces/dialog-position.interface';

export class AppDialogRef<T, R = any> {
  componentInstance!: T;

  readonly componentRef!: ComponentRef<T> | null;

  id: string;

  disableClose: boolean | undefined;

  readonly canceled: Subject<void> = new Subject<void>();

  readonly submitted: Subject<R> = new Subject<R>();

  constructor(
    private _ref: DialogRef<R, T>,
    config: DialogConfig,
  ) {
    this.disableClose = config.disableClose;
    this.id = _ref.id;

    _ref.closed.subscribe(() => {
      this.canceled.complete();
      this.submitted.complete();
    });

    _ref.addPanelClass('app-dialog-panel');

    this.backdropClick.subscribe(() => {
      if (!this.disableClose) {
        this.cancel();
      }
    });
  }

  get closed() {
    return this._ref.closed;
  }

  get backdropClick() {
    return this._ref.backdropClick.pipe();
  }

  close(dialogResult?: R) {
    this._ref.close(dialogResult);
  }

  cancel() {
    this.canceled.next();
    this.close();
  }

  submit(data: R) {
    this.submitted.next(data);
    this.close(data);
  }

  updatePosition(position?: DialogPositionInterface): this {
    let strategy = this._ref.config.positionStrategy as GlobalPositionStrategy;

    if (position && (position.left || position.right)) {
      if (position.left) {
        strategy.left(position.left);
      } else {
        strategy.right(position.right);
      }
    } else {
      strategy.centerHorizontally();
    }

    if (position && (position.top || position.bottom)) {
      if (position.top) {
        strategy.top(position.top);
      } else {
        strategy.bottom(position.bottom);
      }
    } else {
      strategy.centerVertically();
    }

    this._ref.updatePosition();

    return this;
  }

  updateSize(width: string = '', height: string = '') {
    this._ref.updateSize(width, height);
    return this;
  }

  addPanelClass(classes: string | string[]) {
    this._ref.addPanelClass(classes);
    return this;
  }

  removePanelClass(classes: string | string[]) {
    this._ref.removePanelClass(classes);
    return this;
  }
}
